import React, { Fragment, useEffect, useState } from 'react';
import { connect } from "react-redux";
import Sidebar from './../Sidebar';
import ContactSearch from '../ContactBook/ContactSearch';
import ProductSearch from '../ProductMaster/ProductSearch';
import Swal from "sweetalert2";
import { requestSaveCart } from "../../Redux/actions";
import { bindActionCreators } from "redux";
import { Modal, ModalBody, ModalHeader, Row } from "reactstrap";

import {
    Box,
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper
} from '@mui/material';
import { el } from 'date-fns/locale';
import ContactAdd from '../ContactBook/ContactAdd';

const initialTableData = {
    client: '',
    table: '',
    waiter: '',
    items: [],
    discount: 0,
    contact: null
};

function AddCart(props) {
    const [cartData, setCartData] = useState(initialTableData);
    const [selectedTable, setSelectedTable] = useState('');
    const [selectedContact, setSelectedContact] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [products, setProducts] = useState(null);
    const savedData = selectedTable ? localStorage.getItem(`tableData_${selectedTable}`) : null;
    const parsedData = savedData ? JSON.parse(savedData) : null;
    const productList = parsedData?.products || [];
    const [userToken, setUserToken] = useState(0);
    const [updated, setUpdated] = useState(false);
    const [contactmodal, setcontactModal] = useState(false);
    const [deleted, setDeleted] = useState(false);

    function deletedata(idToDelete) {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                setDeleted(true);
                const tableKey = `tableData_${selectedTable}`;
                const storedData = JSON.parse(localStorage.getItem(tableKey)) || {};

                // 🛡️ Safe fallback if products don't exist
                const currentProducts = Array.isArray(storedData.products) ? storedData.products : [];

                // 🔍 Remove only the product with the matching id
                const updatedProducts = currentProducts.filter(item => item.item_id !== idToDelete);
                setProducts(updatedProducts);
                // 🧩 Preserve other table data
                const updatedTableData = {
                    ...storedData,              // Keeps contact, tableNo, etc.
                    products: updatedProducts  // Replaces only the products array
                };

                // 💾 Save back to localStorage
                localStorage.setItem(tableKey, JSON.stringify(updatedTableData));

                // 🔄 Update UI
                // setProductList(updatedProducts);
                setCartData(prev => ({ ...prev, items: updatedProducts }));
            }
        })
    }

    function handleNewClient(e) {
        e.preventDefault();
        contacttoggle();
    }

    const contacttoggle = () => {
        // setcontactModal(!contactmodal);
        setcontactModal(prev => !prev);
    };

    useEffect(() => {
        let data1 = JSON.parse(localStorage.getItem("user"));
        if (data1) {
            setUserToken(data1.data.userToken);
            const savedData = localStorage.getItem(`tableData_${selectedTable}`);
            // if (!Array.isArray(JSON.parse(savedData))) {
            //     localStorage.removeItem(`tableData_${selectedTable}`);
            // }
            const parsedData = savedData ? JSON.parse(savedData) : null;
            if (parsedData) {
                setProducts(parsedData.products); // Or however you're managing this data
                setCartData(prev => ({ ...prev, items: parsedData.products }));
            }
        }
    }, [selectedTable]);

    useEffect(() => {
        if (selectedProduct && selectedTable) {
            setProducts(prev => {
                const current = Array.isArray(prev) ? prev : [];
                const exists = current.some(p => p.item_id === selectedProduct.id);
                if (exists) return current;

                const newItem = [{
                    id: 0,
                    item_id: selectedProduct.id,
                    item_name: selectedProduct.description,
                    price: selectedProduct.sale_price,
                    qty: 1,
                    amount: selectedProduct.sale_price
                }];

                const updated = [...current, ...newItem];

                // 🧩 Build a unified payload with latest cart and contact
                const dataToSave = {
                    tableNo: selectedTable,
                    products: updated,
                    contact: selectedContact
                };

                // 💾 Save only once to the correct table key
                localStorage.setItem(`tableData_${selectedTable}`, JSON.stringify(dataToSave));

                // 🧠 Update states after saving
                setCartData(prev => ({ ...prev, items: updated }));
                setProducts(updated);
                // setTables(prevTables => ({
                //     ...prevTables,
                //     [selectedTable]: dataToSave
                // }));

                return updated;
            });
        }
    }, [selectedProduct]);

    function saveCartToApi() {
        setUpdated(true);
        props.requestSaveCart({
            data: {
                userToken: userToken,
                compToken: localStorage.getItem("companyToken"),
                custId: selectedContact.id,
                cartDatas: products,
                tableNo: selectedTable
            },
        });
    }

    useEffect(() => {
        let saveCartData = props.data.saveCartData;
        if (saveCartData !== undefined && updated) {
            if (saveCartData?.data?.status === 1) {
                Swal.fire({
                    title: 'Good job!',
                    text: 'Cart saved successfully.',
                    icon: 'success'
                });
                setUpdated(false);
                props.data.saveCartData = undefined;
                localStorage.removeItem(`tableData_${selectedTable}`);
            } else {
                Swal.fire({
                    title: 'Error',
                    text: saveCartData?.data?.message || 'Failed to update cart.',
                    icon: 'error'
                });
            }
        }
    }, [props.data.saveCartData]);

    const handleTableSelect = (tableName) => {
        setSelectedTable(tableName);
        if (tableName === '') {
            setCartData(initialTableData);
            setSelectedContact(null);
        } else {
            const saved = localStorage.getItem(`tableData_${tableName}`);
            const parsed = saved ? JSON.parse(saved) : initialTableData;
            setCartData(parsed || initialTableData);

            setSelectedContact(parsed.contact || null);
        }
    };

    const handleQtyChange = (id, newQty) => {
        const updatedProducts = products.map(item =>
            item.item_id === id
                ? { ...item, qty: newQty, amount: newQty * item.price }
                : item
        );
        updateTables(updatedProducts);
    };

    function updateTables(updatedProducts) {
        const updatedTableData = {
            tableNo: selectedTable,
            products: updatedProducts,
            contact: selectedContact
        };

        // Update state
        setProducts(updatedProducts);
        setCartData(prev => ({ ...prev, items: updatedProducts }));

        // Save to localStorage
        localStorage.setItem(`tableData_${selectedTable}`, JSON.stringify(updatedTableData));
    }

    const totalAmount = (cartData.items || []).reduce((sum, item) => sum + item.qty * item.price, 0);

    const grandTotal = totalAmount - (cartData.discount || 0);

    return (
        <Fragment>
            <div class="container-scroller">
                {/* <PageHeader name="Jobs" /> */}
                <div class="container-fluid page-body-wrapper">
                    <Sidebar name="Jobs" />
                    <div class="main-panel">
                        <div class="content-wrapper">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="home-tab">
                                        <div class="row flex-grow">
                                            <div class="grid-margin stretch-card">
                                                <div class="card card-rounded">
                                                    <div class="card-body">
                                                        <div class="col-md-4 card mb-3">
                                                            <div class="card-body">
                                                                <div className="form-group">
                                                                    <ContactSearch onContactSelect={(contact) => {
                                                                        setSelectedContact(contact);
                                                                        setCartData(prev => ({
                                                                            ...prev,
                                                                            contact: contact // 💾 Save into cartData
                                                                        }));
                                                                    }} />
                                                                    <br></br><br></br>
                                                                    {selectedContact !== null ? <div className='row'> <label className="form-label"><b>Name:</b> {selectedContact.name}</label>
                                                                        <label className="form-label"><b>Phone No:</b> {selectedContact.mobile} <b>Email:</b> {selectedContact.email}</label>
                                                                        <div className='row'>{selectedContact.address}</div>
                                                                    </div> : ""}
                                                                </div>
                                                                <button type='button' className='bg-primary' style={{ width: "20px" }} onClick={(e) => handleNewClient(e)}><i className='fa fa-plus' /></button>
                                                                {contactmodal === true && (
                                                                    <Modal
                                                                        isOpen={contactmodal}
                                                                        toggle={contacttoggle}
                                                                        zIndex='999'
                                                                    >
                                                                        <ModalHeader toggle={contacttoggle}>
                                                                            Contact Details
                                                                        </ModalHeader>
                                                                        <ModalBody>
                                                                            <ContactAdd></ContactAdd>
                                                                        </ModalBody>
                                                                    </Modal>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div class="card mb-3">
                                                            <div class="row card-body form-fields">
                                                                <div className='col-md-4'>
                                                                    <input type="text" className="form-control" placeholder="Table Number" onChange={e => handleTableSelect(e.target.value)}></input>
                                                                </div>
                                                                <div className='col-md-4'><ProductSearch onProductSelect={(p) => setSelectedProduct(p)}></ProductSearch></div>
                                                            </div>
                                                        </div>
                                                        <div class="card mb-3">
                                                            <div class="row card-body form-fields">
                                                                <Box sx={{ overflowX: 'auto' }}>
                                                                    <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
                                                                        <Table stickyHeader size="small">
                                                                            <TableHead>
                                                                                <TableRow>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>#</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Item Name</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Price</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Qty</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Amount</TableCell>
                                                                                </TableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                {productList !== null ? productList.map((item, index) => (
                                                                                    <TableRow
                                                                                        key={index}
                                                                                        hover
                                                                                        sx={{
                                                                                            cursor: 'pointer',
                                                                                            backgroundColor: index % 2 === 0 ? 'white' : '#f5f5f5' // Light gray for odd rows
                                                                                        }}
                                                                                    >
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>{index + 1}</TableCell>
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>{item.item_name || '—'}</TableCell>
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>{item.price || '0'}</TableCell>
                                                                                        <TableCell>
                                                                                            <input
                                                                                                type="number"
                                                                                                min="1"
                                                                                                value={item.qty}
                                                                                                onChange={(e) => handleQtyChange(item.item_id, parseInt(e.target.value))}
                                                                                                style={{ width: '60px', padding: '4px' }}
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>{item.amount}</TableCell>
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}><button class="badge badge-opacity-danger" style={{ border: "0px", background: "#fea8a9", marginLeft: "5px", }}
                                                                                            onClick={() => { deletedata(item.item_id); }}><i class="fa fa-trash"></i></button></TableCell>
                                                                                    </TableRow>
                                                                                )) : ""}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </TableContainer>
                                                                </Box>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <button onClick={() => {
                                if (selectedTable !== '') {
                                    setTables({ ...tables, [selectedTable]: cartData });
                                    alert('Data saved for table: ' + selectedTable);
                                }
                            }}>Save Table Data</button> */}
                            <div
                                style={{
                                    position: 'sticky',
                                    bottom: 0,
                                    width: '100%',
                                    background: '#fff',
                                    boxShadow: '0 -2px 5px rgba(0,0,0,0.1)',
                                    padding: '1rem',
                                    zIndex: 99
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        flexWrap: 'wrap'
                                    }}
                                >
                                    <strong style={{ fontSize: '1.2rem' }}>Grand Total: ₹{grandTotal}</strong>
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => { saveCartToApi() }}
                                    >
                                        Save Cart
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = (state) => {
    return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ requestSaveCart }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddCart);